import { useDispatch } from "react-redux";
import {
    setFloatingContainerState,
    setFloatingWindowState,
    setHeaderState,
    setQuitConfirmationState,
    setSendMessageContainerState
} from "../../../features/componentStateSlice.js";
import { setIsEnd } from "../../../features/messagesSlice.js";

export default function QuitButton() {
    const dispatch = useDispatch();

    const handleQuitButtonClick = () => {
        dispatch(setIsEnd(true));
        dispatch(setQuitConfirmationState(false));
        dispatch(setFloatingContainerState(true));
        dispatch(setFloatingWindowState(false));
        dispatch(setHeaderState(false));
        dispatch(setSendMessageContainerState(false));
    };

    return (
        <button id="quit-button" onClick={ handleQuitButtonClick }>Quit</button>
    );
};
